import type { TFunction } from 'i18next';

const oneMillion = 1_000_000;
const oneThousand = 1_000;

const oneMillionBorder = 999_951;
const oneThousandBorder = 951;

export const formatReachValue = (t: TFunction, reach?: number | null): string => {
  if (typeof reach !== 'number') return t('N / A');

  if (reach >= oneMillionBorder) {
    return `${Intl.NumberFormat('en-US', {
      style: 'decimal',
      maximumFractionDigits: 1,
    }).format(reach / oneMillion)}M`;
  }

  if (reach >= oneThousandBorder && reach < oneMillionBorder) {
    return `${Intl.NumberFormat('en-US', {
      style: 'decimal',
      maximumFractionDigits: 1,
    }).format(reach / oneThousand)}K`;
  }

  return Intl.NumberFormat('en-US', {
    style: 'decimal',
    maximumFractionDigits: 0,
  }).format(reach);
};
